export enum UserRole {
    Admin = 'ROLE_SULU_SYNERGY_ADMIN',
    SuperAdmin = 'ROLE_SULU_SUPERADMIN',
    Sales = 'ROLE_SULU_SYNERGY_SALES',
    Accounting = 'ROLE_SULU_SYNERGY_ACCOUNTING',
    ShopAdmin = 'ROLE_SULU_SHOPADMIN',
    Extranet = 'ROLE_SULU_EXTRANET',
    SupplierAdmin = 'ROLE_SULU_SYNERGY_SUPPLIER_ADMIN',
    Configuration = 'ROLE_SULU_SYNERGY_IMPORT',
    ImportApi = 'ROLE_SULU_SYNERGY_IMPORT_API',
    ShopUser = 'ROLE_SULU_SHOP',
    SuluAdmin = 'ROLE_SULU_ADMIN',
    CustomerBonusContact = 'ROLE_CUSTOMER_BONUS_CONTACT',
    SupplierBonusContact = 'ROLE_SUPPLIER_BONUS_CONTACT',
}
